import { Component, inject } from '@angular/core';
import { GeneralInfoComponent } from "../article-artistic-cards/general-info/general-info.component";
import { Router } from '@angular/router';
import { ConnectServerService } from '../../../services/connect-server.service';
import { Connect } from '../../../classes/connect';
import { ApiResponse } from '../../../interfaces/api-response';
import { SelectOptions } from '../interfaces/select-options';
import { PopupDialogService } from '../../../services/popup-dialog.service';
import { SelectRegionCode } from '../interfaces/select-region-code';

@Component({
    selector: 'app-article-artistic-insert',
    imports: [
        GeneralInfoComponent
    ],
    templateUrl: './article-artistic-insert.component.html',
    styleUrl: './article-artistic-insert.component.scss'
})
export class ArticleArtisticInsertComponent {
  readonly connectServerService = inject(ConnectServerService);
  readonly popupDialogService = inject(PopupDialogService);
  constructor(private router: Router) {
    this.getArticleType();
    this.getRegionCode();
  }

  listType: SelectOptions[] = [];
  listRegionsCode: SelectRegionCode[] = [];

  onButtonClicked(event: any) {
    if (Object.keys(event).length > 0) {
      this.connectServerService.postRequest<ApiResponse<{ id: number }>>('insertArticleArtistic',
        event
      ).subscribe(
        (esito: ApiResponse<{ id: number }>) => {
          this.popupDialogService.popupDialog(esito);
          this.router.navigate(["modificaSchedaArtistica", esito.data.id])
        }
      );
    }
  }

  private getArticleType() {
    this.connectServerService.getRequest('listAAType', {})
      .subscribe(
        (val: ApiResponse<{ listType: SelectOptions[] }>) => {
          this.listType = val.data.listType;
        }
      )
  }
  goBack(): void {
    window.history.back();
  }

  private getRegionCode() {
    this.connectServerService.getRequest('listAARegionCode', {})
      .subscribe(
        (val: ApiResponse<{ listRegionCode: SelectRegionCode[] }>) => {
          this.listRegionsCode = val.data.listRegionCode;
        }
      )
  }
}
